import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {EmailThread} from '@features/inbox/interfaces/email-thread-label';

@Component({
    standalone: false,
    selector: 'app-email-thread-container',
  templateUrl: './email-thread-container.component.html',
  styleUrls: ['./email-thread-container.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailThreadContainerComponent implements OnInit {
  @Input() emailThreadId: string;
  emailThread: EmailThread = {} as EmailThread;

  constructor() {
  }

  ngOnInit(): void {
    this.emailThread.labels = [
      {
        title: 'Important',
        color: '#eb3475'
      },
      {
        title: 'Meetings',
        color: '#3cbb3b'
      },
      {
        title: 'A long label containing so many words',
        color: '#7d7eff'
      }
    ];
    this.emailThread.emails = [];
    this.emailThread.emails.push({
      content: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">

<html xmlns="http://www.w3.org/1999/xhtml">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <style>
      body {
          color: #252D44;
          font-size: 18px;
          line-height: 30px;
          background: #F4F5FB;
          font-style: normal;
          font-weight: 500;
          font-family: 'Inter', "SF Pro Display", Arial, sans-serif;
          padding: 0;
      }
  </style>

</head>

<body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">

  <!-- <span class="preheader" style="display: none !important;">You have received a new message regarding an EY Tax Alert (via Orbitax)</span> -->

  <center>
      <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" bgcolor="F4F5FB">
          <tbody>
              <tr>
                  <td id="wrap" style="padding: 100px 0; margin: 20px 0; background: #F4F5FB;">
                      <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="600"
                             id="container_table">
                          <tbody>
                              <tr>
                                  <td style="padding: 0;margin: 20px 0;">

                                      <table width="100%" align="center" border="0" cellpadding="0" cellspacing="0"
                                             height="100%">
                                          <!-- Header -->
                                          <tbody>
                                              <tr>
                                                  <td class="logo"
                                                      style="padding: 0;margin: 20px 0;padding-bottom: 30px;">
                                                      <center>
                                                          <img src="https://orbitaxservices.com/orbitax-assets/images/ey/logo.png" width="120" alt="Orbitax" border="0"
                                                               style="border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" />
                                                      </center>
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td id="content" bgcolor="#ffffff"
                                                      style="background: #ffffff;padding: 20px 30px 30px 30px;margin: 20px 0;border-top: 5px solid #252D44;">
                                                      <table width="100%" align="center" border="0" cellpadding="0"
                                                             cellspacing="0" height="100%">
                                                          <tbody>
                                                              <tr>
                                                                  <td class="company" align="right"
                                                                      style="padding: 0;margin: 20px 0;">
                                                                      <h4 style="padding: 0;margin: 0;font-size: 12px;color: #9296B5;font-weight: 400;">
                                                                          &nbsp;
                                                                      </h4>
                                                                  </td>
                                                              </tr>

                                                              <tr>
                                                                  <td class="icon"
                                                                      style="padding: 0 0 20px;margin: 20px 0;">
                                                                      <img width="86px" height="100px"
                                                                           viewBox="0 0 86 100"
                                                                           src="https://orbitaxservices.com/orbitax-assets/images/ey/EY.png" />

                                                                  </td>
                                                              </tr>
                                                              <tr>
                                                                  <td class="intro"
                                                                      style="padding: 0;margin: 20px 0;">
                                                                      <h2 style="padding: 0;margin: 20px 0;font-size: 24px;font-weight: 600;">
                                                                          Hi {{Data.MemberName}},
                                                                      </h2>

                                                                      <p>
                                                                          You have received a new message regarding the
                                                                          Expert Service via the Orbitax International Tax Platform:
                                                                      </p>

                                                                      <h1 style="padding: 0;margin: 20px 0;font-size: 24px;line-height: 40px;">
                                                                          {{Data.Subject}}
                                                                      </h1>

                                                                      <table width="100%" border="0" cellpadding="0" cellspacing="0" style="margin: 20px 0;border-radius: 10px;background: #F8F8FC;">
                                                                          <tbody>
                                                                              <tr>
                                                                                  <td valign="top" style="padding: 10px 20px; background: #E3E4EC;border-radius: 10px 10px 0 0;">
                                                                                      Message:
                                                                                  </td>
                                                                              </tr>
                                                                              <tr>
                                                                                  <td valign="top" style="padding: 20px;">
                                                                                      {{Data.Description}}
                                                                                      <div class="meta" style="margin-top: 10px;font-size: 14px;color: #9296B5;">
                                                                                          {{Data.TimeStamp}}
                                                                                      </div>
                                                                                  </td>
                                                                              </tr>
                                                                          </tbody>
                                                                      </table>

                                                                      <a href="{{Data.MessageMagicLink}}" class="button onesource"
                                                                         style="text-decoration: none;color: #ffffff;display: inline-block;line-height: 50px;background: #175CFF;padding: 0 20px;font-size: 16px;border-radius: 5px;font-weight: 500;margin: 10px 0;">
                                                                          View and reply to this message →
                                                                      </a>

                                                                      <h3 style="padding: 0;margin: 40px 0 0;font-size: 14px;color: #9296B5;font-weight: 400;line-height: 25px;">
                                                                          You received this email because you are
                                                                          assigned as the contact for Expert Service
                                                                          which was published inside the <a href="{{Data.RootUrl}}"
                                                                                                            target="_BLANK"
                                                                                                            style="text-decoration: underline;color: #9296B5;">
                                                                              Orbitax International Tax Platform
                                                                          </a>.
                                                                      </h3>
                                                                  </td>
                                                              </tr>
                                                          </tbody>
                                                      </table>
                                                  </td>
                                              </tr>

                                              <!-- Footer -->
                                              <tr>
                                                  <td id="footer"
                                                      style="padding: 0;margin: 20px 0;padding-top: 20px;">
                                                      <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                                          <tbody>
                                                              <tr>
                                                                  <td class="footer_content"
                                                                      style="padding: 0;margin: 20px 0;font-size: 12px;line-height: 20px;color: #9296B5;">
                                                                      <center>
                                                                          <p style="display: inline-block;">
                                                                              © {{Data.CopyrightYear}}
                                                                              Orbitax LLC. All Rights Reserved.<br />995
                                                                              Market
                                                                              Street&nbsp;&nbsp;•&nbsp;&nbsp;San
                                                                              Francisco,
                                                                              CA&nbsp;&nbsp;•&nbsp;&nbsp;94103&nbsp;&nbsp;•&nbsp;&nbsp;United
                                                                              States
                                                                          </p>

                                                                          <br /><br /><a href="https://www.linkedin.com/company/orbitax"
                                                                                         target="_BLANK"
                                                                                         style="text-decoration: underline;color: #9296B5;">
                                                                              <img src="https://orbitaxservices.com/orbitax-assets/images/ey/linkedin.png" width="18"
                                                                                   alt="Follow Orbitax on LinkedIn"
                                                                                   border="0"
                                                                                   style="border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" />
                                                                          </a>
                                                                      </center>
                                                                  </td>
                                                              </tr>
                                                          </tbody>
                                                      </table>
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </td>
              </tr>
          </tbody>
      </table>
  </center>



</body>

</html>`,
      recipients: {
        cc: [
          {
            firstName: 'Wasif',
            lastName: 'Mustahid',
            email: 'wasif.mustahid@orbitax.com',
            companyName: 'Molliks Company',
            designation: '',
            username: '',
            companyId: ''
          },
          {
            firstName: 'Oliver',
            lastName: 'Long',
            email: 'oliver.long@orbitax.com',
            companyName: 'Molliks Company',
            designation: '',
            username: '',
            companyId: ''
          },
        ],
        to: {
          firstName: 'Masum',
          lastName: 'Mollik',
          email: 'masum.mollik@orbitax.com',
          companyName: 'Molliks Company',
          designation: '',
          username: '',
          companyId: ''
        }
      },
      isImportant: true,
      sender: {
        firstName : 'Masum',
        lastName : 'Mollik',
        email : 'masum.mollik@orbitax.com',
        companyId: '',
        username: '',
        designation: '',
        companyName: 'Mollik Company',
      },
      sentTime: new Date(2020, 2, 10, 3)
    });
    this.emailThread.emails.push({
      content: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">

<html xmlns="http://www.w3.org/1999/xhtml">

<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <style>
      body {
          color: #252D44;
          font-size: 18px;
          line-height: 30px;
          background: #F4F5FB;
          font-style: normal;
          font-weight: 500;
          font-family: 'Inter', "SF Pro Display", Arial, sans-serif;
          padding: 0;
      }
  </style>

</head>

<body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0">

  <!-- <span class="preheader" style="display: none !important;">You have received a new message regarding an EY Tax Alert (via Orbitax)</span> -->

  <center>
      <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" bgcolor="F4F5FB">
          <tbody>
              <tr>
                  <td id="wrap" style="padding: 100px 0; margin: 20px 0; background: #F4F5FB;">
                      <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="600"
                             id="container_table">
                          <tbody>
                              <tr>
                                  <td style="padding: 0;margin: 20px 0;">

                                      <table width="100%" align="center" border="0" cellpadding="0" cellspacing="0"
                                             height="100%">
                                          <!-- Header -->
                                          <tbody>
                                              <tr>
                                                  <td class="logo"
                                                      style="padding: 0;margin: 20px 0;padding-bottom: 30px;">
                                                      <center>
                                                          <img src="https://orbitaxservices.com/orbitax-assets/images/ey/logo.png" width="120" alt="Orbitax" border="0"
                                                               style="border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" />
                                                      </center>
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td id="content" bgcolor="#ffffff"
                                                      style="background: #ffffff;padding: 20px 30px 30px 30px;margin: 20px 0;border-top: 5px solid #252D44;">
                                                      <table width="100%" align="center" border="0" cellpadding="0"
                                                             cellspacing="0" height="100%">
                                                          <tbody>
                                                              <tr>
                                                                  <td class="company" align="right"
                                                                      style="padding: 0;margin: 20px 0;">
                                                                      <h4 style="padding: 0;margin: 0;font-size: 12px;color: #9296B5;font-weight: 400;">
                                                                          &nbsp;
                                                                      </h4>
                                                                  </td>
                                                              </tr>

                                                              <tr>
                                                                  <td class="icon"
                                                                      style="padding: 0 0 20px;margin: 20px 0;">
                                                                      <img width="86px" height="100px"
                                                                           viewBox="0 0 86 100"
                                                                           src="https://orbitaxservices.com/orbitax-assets/images/ey/EY.png" />

                                                                  </td>
                                                              </tr>
                                                              <tr>
                                                                  <td class="intro"
                                                                      style="padding: 0;margin: 20px 0;">
                                                                      <h2 style="padding: 0;margin: 20px 0;font-size: 24px;font-weight: 600;">
                                                                          Hi {{Data.MemberName}},
                                                                      </h2>

                                                                      <p>
                                                                          You have received a new message regarding the
                                                                          Expert Service via the Orbitax International Tax Platform:
                                                                      </p>

                                                                      <h1 style="padding: 0;margin: 20px 0;font-size: 24px;line-height: 40px;">
                                                                          {{Data.Subject}}
                                                                      </h1>

                                                                      <table width="100%" border="0" cellpadding="0" cellspacing="0" style="margin: 20px 0;border-radius: 10px;background: #F8F8FC;">
                                                                          <tbody>
                                                                              <tr>
                                                                                  <td valign="top" style="padding: 10px 20px; background: #E3E4EC;border-radius: 10px 10px 0 0;">
                                                                                      Message:
                                                                                  </td>
                                                                              </tr>
                                                                              <tr>
                                                                                  <td valign="top" style="padding: 20px;">
                                                                                      {{Data.Description}}
                                                                                      <div class="meta" style="margin-top: 10px;font-size: 14px;color: #9296B5;">
                                                                                          {{Data.TimeStamp}}
                                                                                      </div>
                                                                                  </td>
                                                                              </tr>
                                                                          </tbody>
                                                                      </table>

                                                                      <a href="{{Data.MessageMagicLink}}" class="button onesource"
                                                                         style="text-decoration: none;color: #ffffff;display: inline-block;line-height: 50px;background: #175CFF;padding: 0 20px;font-size: 16px;border-radius: 5px;font-weight: 500;margin: 10px 0;">
                                                                          View and reply to this message →
                                                                      </a>

                                                                      <h3 style="padding: 0;margin: 40px 0 0;font-size: 14px;color: #9296B5;font-weight: 400;line-height: 25px;">
                                                                          You received this email because you are
                                                                          assigned as the contact for Expert Service
                                                                          which was published inside the <a href="{{Data.RootUrl}}"
                                                                                                            target="_BLANK"
                                                                                                            style="text-decoration: underline;color: #9296B5;">
                                                                              Orbitax International Tax Platform
                                                                          </a>.
                                                                      </h3>
                                                                  </td>
                                                              </tr>
                                                          </tbody>
                                                      </table>
                                                  </td>
                                              </tr>

                                              <!-- Footer -->
                                              <tr>
                                                  <td id="footer"
                                                      style="padding: 0;margin: 20px 0;padding-top: 20px;">
                                                      <table width="100%" border="0" cellpadding="0" cellspacing="0">
                                                          <tbody>
                                                              <tr>
                                                                  <td class="footer_content"
                                                                      style="padding: 0;margin: 20px 0;font-size: 12px;line-height: 20px;color: #9296B5;">
                                                                      <center>
                                                                          <p style="display: inline-block;">
                                                                              © {{Data.CopyrightYear}}
                                                                              Orbitax LLC. All Rights Reserved.<br />995
                                                                              Market
                                                                              Street&nbsp;&nbsp;•&nbsp;&nbsp;San
                                                                              Francisco,
                                                                              CA&nbsp;&nbsp;•&nbsp;&nbsp;94103&nbsp;&nbsp;•&nbsp;&nbsp;United
                                                                              States
                                                                          </p>

                                                                          <br /><br /><a href="https://www.linkedin.com/company/orbitax"
                                                                                         target="_BLANK"
                                                                                         style="text-decoration: underline;color: #9296B5;">
                                                                              <img src="https://orbitaxservices.com/orbitax-assets/images/ey/linkedin.png" width="18"
                                                                                   alt="Follow Orbitax on LinkedIn"
                                                                                   border="0"
                                                                                   style="border: 0;height: auto;line-height: 100%;outline: none;text-decoration: none;" />
                                                                          </a>
                                                                      </center>
                                                                  </td>
                                                              </tr>
                                                          </tbody>
                                                      </table>
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </td>
              </tr>
          </tbody>
      </table>
  </center>



</body>

</html>`,
      recipients: {
        cc: [
          {
            firstName: 'Wasif',
            lastName: 'Mustahid',
            email: 'wasif.mustahid@orbitax.com',
            companyName: 'Molliks Company',
            designation: '',
            username: '',
            companyId: ''
          },
          {
            firstName: 'Oliver',
            lastName: 'Long',
            email: 'oliver.long@orbitax.com',
            companyName: 'Molliks Company',
            designation: '',
            username: '',
            companyId: ''
          },
        ],
        to: {
          firstName: 'Masum',
          lastName: 'Mollik',
          email: 'masum.mollik@orbitax.com',
          companyName: 'Molliks Company',
          designation: '',
          username: '',
          companyId: ''
        }
      },
      isImportant: true,
      sender: {
        firstName : 'Masum',
        lastName : 'Mollik',
        email : 'masum.mollik@orbitax.com',
        companyId: '',
        username: '',
        designation: '',
        companyName: 'Mollik Company',
      },
      sentTime: new Date(2020, 2, 10, 3)
    });
  }
}
